import type * as React from 'react';

import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import SectionMessage from './SectionMessage';

type Props = {
  isEmpty: boolean;
  /** Shown in place of the card when there is nothing in the list. */
  emptyMessage: string;
  children: React.ReactNode;
};

export default function TicketList({ isEmpty, emptyMessage, children }: Props) {
  if (isEmpty) return <SectionMessage>{emptyMessage}</SectionMessage>;

  return <html.div style={styles.card}>{children}</html.div>;
}

const styles = css.create({
  card: {
    backgroundColor: color.neutral0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    borderRadius: 12,
    overflow: 'hidden',
  },
});
